import { useState, useEffect, useRef } from 'react'
import { isCancel } from 'axios'
import { getApiClient, MetricItem } from '../api'
import type { GeoItem } from '../types/Stats'

export function useStatsTopBarOptions(scope: string, geo: string) {
  const [rawGeoOptions,    setRawGeoOptions]    = useState<GeoItem[]>([])
  const [rawMetricOptions, setRawMetricOptions] = useState<MetricItem[]>([])
  const [geoError,    setGeoError]    = useState(false)
  const [metricError, setMetricError] = useState(false)

  const geoAbortRef    = useRef<AbortController | null>(null)
  const metricAbortRef = useRef<AbortController | null>(null)

  useEffect(() => {
    if (!scope) return
    geoAbortRef.current?.abort()
    const controller = new AbortController()
    geoAbortRef.current = controller

    setGeoError(false)
    setRawMetricOptions([])
    getApiClient()
      .getGeoByScope(scope, { signal: controller.signal })
      .then(data => setRawGeoOptions((data.data ?? []) as GeoItem[]))
      .catch((err: unknown) => {
        if (isCancel(err)) return
        console.error('Failed to load geo list', err)
        setRawGeoOptions([])
        setGeoError(true)
      })

    return () => controller.abort()
  }, [scope])

  useEffect(() => {
    if (!scope || !geo) return
    metricAbortRef.current?.abort()
    const controller = new AbortController()
    metricAbortRef.current = controller

    setMetricError(false)
    setRawMetricOptions([])
    getApiClient()
      .getMetricsByScope(scope, { geo }, { signal: controller.signal })
      .then(data => setRawMetricOptions((data.data ?? []) as MetricItem[]))
      .catch((err: unknown) => {
        if (isCancel(err)) return
        console.error('Failed to load metrics', err)
        setRawMetricOptions([])
        setMetricError(true)
      })

    return () => controller.abort()
  }, [scope, geo])

  return { rawGeoOptions, rawMetricOptions, geoError, metricError }
}
